import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 施設関係者メッセージ送信(未読/既読) API 操作クラス
 */
export default class OtherUserGroupSendMessageReadCounts {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserGroupSendMessageReadCounts
   */
  public async get(userStore: LoginUser, datetime: number): Promise<SendMessageReadCountsModel> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupSendMessageReadCounts, formatParams);
    const response = await this.commonService.executeGet<SendMessageReadCountsModel>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * メッセージ送信(未読/既読)
 */
export interface SendMessageReadCountsModel {
  /** 未読家族数 */
  readCounts: number;
  /** 既読家族数 */
  unreadCounts: number;
}
